var map = {
	"./blog/menus.json": "39c6",
	"./management/menus.json": "eb0e",
	"./newsletters/menus.json": "b839",
	"./notifications/menus.json": "fdcf",
	"./payment/menus.json": "31db",
	"./shop/menus.json": "dcd2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "791e";